import React from 'react';
import { useFormContext } from 'react-hook-form/dist/index.ie11';
import { Copy } from '@grubhubprod/gh-cookbook-react';
import { CookbookCheckboxWrapper } from 'src/components/CookbookCheckboxWrapper/CookbookCheckboxWrapper';
import { CustomLabelWithTooltip } from 'src/components/common/CustomLabelWithTooltip/CustomLabelWithTooltip';

export interface AllowAllocationsControlProps {
  name: string;
  id: string;
}

export function AllowAllocationsControl({
  name,
  id,
}: AllowAllocationsControlProps): JSX.Element {
  const { control } = useFormContext();

  return (
    <CookbookCheckboxWrapper
      control={control}
      id={id}
      name={name}
      aria-label="AllowAllocations"
      label={
        <CustomLabelWithTooltip
          color="primaryText"
          labelText="Allow allocations"
          tooltipInfo={
            <Copy variant="body" color="invertedPrimaryText">
              Give this employee access to their colleagues' budgets so they can
              order for them or together in a single order.
            </Copy>
          }
        />
      }
    />
  );
}
